<div class="h-full flex flex-col">
  <app-header></app-header>
  <div class="grow overflow-y-auto flex flex-col items-center">
    <main
      class="grow w-full flex flex-col gap-16 md:gap-28 px-5 md:w-4/5 lg:w-3/4"
    >
      @if (loadingInitData) {
      <!-- Contenido de carga. -->
      <div class="mt-16 md:mt-28 flex flex-col gap-4">
        <div class="h-8 w-1/3 bg-gray-200 cursor-wait animate-pulse"></div>
        <div class="h-8 w-full bg-gray-200 cursor-wait animate-pulse"></div>
      </div>
      <div class="flex flex-col gap-20">
        <div class="flex flex-col gap-8">
          <div class="h-8 w-1/6 bg-gray-200 cursor-wait animate-pulse"></div>
          <div class="h-12 w-2/5 bg-gray-200 cursor-wait animate-pulse"></div>
          <div class="flex gap-10">
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
          </div>
        </div>
        <div class="flex flex-col gap-8">
          <div class="h-8 w-1/6 bg-gray-200 cursor-wait animate-pulse"></div>
          <div class="h-12 w-2/5 bg-gray-200 cursor-wait animate-pulse"></div>
          <div class="flex gap-10">
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
          </div>
          <div class="flex gap-10">
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
          </div>
          <div class="flex gap-10">
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
          </div>
        </div>
        <div class="flex flex-col gap-8">
          <div class="h-8 w-1/6 bg-gray-200 cursor-wait animate-pulse"></div>
          <div class="flex gap-10">
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
            <div class="h-12 w-1/2 bg-gray-200 cursor-wait animate-pulse"></div>
          </div>
          <div class="h-16 w-full bg-gray-200 cursor-wait animate-pulse"></div>
        </div>
        <div class="flex flex-col items-center">
          <div class="h-12 w-1/4 bg-gray-200 cursor-wait animate-pulse"></div>
        </div>
      </div>
      } @else { @if (product.id) {
      <!-- Título y subtitulo -->
      <section class="mt-16 md:mt-28 flex flex-col gap-4">
        <h1 class="text-4xl font-medium md:text-5xl">
          Activación {{ product.name }}
        </h1>
        <p class="text-lg md:text-xl">
          {{ product.description }}
        </p>
      </section>

      <!-- Formulario -->
      <form
        [formGroup]="form"
        (ngSubmit)="generateActivation()"
        class="flex flex-col gap-20"
      >
        <!-- Configuración de licencia -->
        <div class="flex flex-col gap-8">
          <h2 class="text-md font-medium uppercase text-[#005cbb]">Licencia</h2>
          <div class="w-full flex flex-col gap-5" formGroupName="license">
            @if (types.length) {
            <mat-radio-group
              formControlName="type"
              class="flex flex-wrap gap-4"
            >
              @for (type of types; track type.value) {
              <mat-radio-button [value]="type.value">
                <span class="text-base cursor-pointer">{{ type.name }}</span>
              </mat-radio-button>
              }
            </mat-radio-group>
            } @else {
            <div class="text-gray-500">No hay tipos disponibles</div>
            }

            <div
              class="flex flex-col gap-4 w-full md:flex-row md:gap-24 md:items-center"
            >
              <div class="w-full md:w-2/4">
                @if (licenses.length) {
                <mat-form-field class="w-full">
                  <mat-label>Elige la licencia</mat-label>
                  <mat-select formControlName="license">
                    @for (license of licenses; track license.id) {
                    <mat-option [value]="license.id">{{
                      license.name
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                } @else {
                <div class="text-gray-500">No hay licencias disponibles</div>
                }
              </div>
              <div class="w-full md:w-2/4">
                @if (hosts.length) {
                <mat-radio-group
                  formControlName="host"
                  class="flex flex-wrap gap-4"
                >
                  @for (host of hosts; track host.id) {
                  <mat-radio-button [value]="host.id">
                    <span class="text-base cursor-pointer">{{
                      host.name
                    }}</span>
                  </mat-radio-button>
                  }
                </mat-radio-group>
                } @else {
                <div class="text-gray-500">No hay hosts disponibles</div>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Configuración del cliente -->
        <div class="flex flex-col gap-8">
          <h2 class="text-md font-medium uppercase text-[#005cbb]">Cliente</h2>
          <div class="w-full flex flex-col gap-4" formGroupName="customer">
            <mat-slide-toggle
              formControlName="new"
              (change)="onCustomerNewChange()"
            >
              <span class="text-base pl-2">¿Es nuevo?</span>
            </mat-slide-toggle>
            @if (!formCustomerNew?.value) {
            <div
              class="flex flex-col gap-5 md:flex-row md:gap-24 md:items-center"
            >
              <div class="flex gap-5 items-center w-full md:w-2/4">
                <mat-form-field class="grow">
                  <mat-label>Buscar</mat-label>
                  <input
                    type="text"
                    name="generalSearch"
                    placeholder="Escribe el nombre, NIF o referencia"
                    [readonly]="loadingGeneralSearchCustomer"
                    formControlName="generalSearch"
                    [matAutocomplete]="auto"
                    matInput
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    (optionSelected)="onCustomerSearchSelected($event)"
                  >
                    @for (searchedCustomer of searchedCustomers; track
                    searchedCustomer) {
                    <mat-option [value]="searchedCustomer.reference">
                      <div class="flex flex-col">
                        {{ searchedCustomer.name }}
                        <small class="text-gray-500">
                          {{ searchedCustomer.tradeName }} ·
                          {{ searchedCustomer.reference }}
                        </small>
                      </div>
                    </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-hint align="start" class="text-gray-500">
                    La búsqueda se realiza en el sistema Dansap.
                  </mat-hint>
                  @if
                  (formCustomerGeneralSearch?.hasError('customerSearchError')) {
                  <mat-error
                    >Ha ocurrido un error al buscar el cliente.</mat-error
                  >
                  }
                </mat-form-field>
                @if (loadingGeneralSearchCustomer) {
                <mat-spinner diameter="25"></mat-spinner>
                }
              </div>
              <div class="flex gap-5 items-center w-full md:w-2/4">
                <mat-form-field class="grow">
                  <mat-label>Buscar por referencia</mat-label>
                  <input
                    type="text"
                    name="referenceSearch"
                    placeholder="Escribe la referencia"
                    [readonly]="loadingReferenceSearchCustomer"
                    formControlName="referenceSearch"
                    matInput
                  />
                  <mat-hint align="start" class="text-gray-500">
                    La búsqueda se realiza en el sistema Dansap.
                  </mat-hint>
                  @if(formCustomerReferenceSearch?.hasError('invalidReference'))
                  {
                  <mat-error>El código del cliente no es válido.</mat-error>
                  } @if
                  (formCustomerReferenceSearch?.hasError('customerSearchError'))
                  {
                  <mat-error
                    >Ha ocurrido un error al buscar el cliente.</mat-error
                  >
                  }
                </mat-form-field>
                @if (loadingReferenceSearchCustomer) {
                <mat-spinner diameter="25"></mat-spinner>
                }
              </div>
            </div>
            } @if ((!formCustomerNew?.value && formCustomerNif?.value) ||
            formCustomerNew?.value) {
            <div class="flex flex-col gap-4">
              <div
                class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
              >
                @if(!formCustomerNew?.value) {
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Referencia</mat-label>
                  <input
                    type="text"
                    name="reference"
                    readonly="true"
                    formControlName="reference"
                    matInput
                  />
                </mat-form-field>
                }
                <mat-form-field
                  [ngClass]="{
                    'w-full': formCustomerNew?.value,
                    'md:w-2/4': !formCustomerNew?.value
                  }"
                >
                  <mat-label>Nombre</mat-label>
                  <input
                    type="text"
                    name="name"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="name"
                    matInput
                  />
                </mat-form-field>
              </div>
              <div
                class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
              >
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>NIF</mat-label>
                  <input
                    type="text"
                    name="nif"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="nif"
                    matInput
                  />
                </mat-form-field>
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Nombre comercial</mat-label>
                  <input
                    type="text"
                    name="tradeName"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="tradeName"
                    matInput
                  />
                </mat-form-field>
              </div>
              <div
                class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
              >
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Teléfono</mat-label>
                  <input
                    type="tel"
                    name="telephone"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="telephone"
                    matInput
                  />
                </mat-form-field>
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Provincia</mat-label>
                  <input
                    type="text"
                    name="province"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="province"
                    matInput
                  />
                </mat-form-field>
              </div>
              <div
                class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
              >
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>País</mat-label>
                  <input
                    type="text"
                    name="country"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="country"
                    matInput
                  />
                </mat-form-field>
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Dirección</mat-label>
                  <input
                    type="text"
                    name="address"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="address"
                    matInput
                  />
                </mat-form-field>
              </div>
              <div
                class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
              >
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Población</mat-label>
                  <input
                    type="text"
                    name="city"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="city"
                    matInput
                  />
                </mat-form-field>
                <mat-form-field class="w-full md:w-2/4">
                  <mat-label>Código postal</mat-label>
                  <input
                    type="text"
                    name="postalCode"
                    [readonly]="!formCustomerNew?.value"
                    formControlName="postalCode"
                    matInput
                  />
                </mat-form-field>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- Configuración de activación -->
        <div class="flex flex-col gap-8">
          <h2 class="text-md font-medium uppercase text-[#005cbb]">
            Activación
          </h2>
          <div class="w-full flex flex-col gap-4" formGroupName="activation">
            <div
              class="flex flex-col gap-4 md:flex-row md:gap-24 md:items-center"
            >
              <div class="flex gap-5 items-center w-full md:w-2/4">
                <mat-form-field class="grow">
                  <mat-label>Código</mat-label>
                  <input
                    type="text"
                    name="code"
                    placeholder="Ex. AFMCHJ"
                    maxlength="6"
                    formControlName="code"
                    matInput
                  />
                </mat-form-field>
                <mat-hint align="end" class="whitespace-nowrap"
                  >{{
                    formActivationCode?.value
                      ? formActivationCode?.value.length
                      : 0
                  }}
                  / 6</mat-hint
                >
              </div>
              <mat-form-field class="w-full md:w-2/4">
                <mat-label>Fecha de expiración</mat-label>
                <input
                  name="expirationDate"
                  placeholder="DD/MM/YYYY"
                  formControlName="expirationDate"
                  [matDatepicker]="picker"
                  matInput
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker xPosition="end"></mat-datepicker>
                <mat-hint align="start" class="text-gray-500"
                  >La fecha debe seguir el formato DD/MM/YYYY.</mat-hint
                >
              </mat-form-field>
            </div>
            <mat-form-field class="w-full">
              <mat-label>Comentario</mat-label>
              <textarea
                name="comment"
                formControlName="comment"
                matInput
              ></textarea>
            </mat-form-field>
          </div>
        </div>

        <!-- Errores -->
        @if (generateActivationErrors) { @for (error of
        generateActivationErrors; track error) {
        <div class="text-center text-sm text-red-500">
          {{ error }}
        </div>
        } }

        <!-- Botón de enviar -->
        <div class="flex items-center justify-center w-full">
          <button
            type="submit"
            class="w-96"
            mat-flat-button
            [disabled]="form.invalid || loadingGenerateActivation"
          >
            @if (loadingGenerateActivation) {
            <mat-spinner diameter="18"></mat-spinner>
            } @else {
            <span class="text-base">Generar activación</span>
            }
          </button>
        </div>
      </form>

      } @else {
      <!-- Sección de producto no encontrado. -->
      <section class="mt-28 text-center flex flex-col gap-4">
        <h1 class="text-4xl font-medium md:text-5xl">Producto no encontrado</h1>
        <p class="text-lg md:text-xl">
          Vuelve a las
          <a routerLink="/activations" class="text-[#005cbb]">activaciones</a>
          y selecciona otro producto.
        </p>
      </section>
      } }
    </main>

    <!-- Pie de página. -->
    <app-footer></app-footer>
  </div>
</div>
